<script setup lang="ts">
import type { SaveButtonType } from '#layers/listing/types/listing';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAppConfig } from '#app/config';

interface Props {
	saveButtonType: SaveButtonType;
}

const { saveButtonType } = defineProps<Props>();

const emit = defineEmits<{
	save: [];
	saveToView: [];
	saveAsNew: [];
	reset: [];
}>();

const { t } = useI18n();
const appConfig = useAppConfig();

const dropdownItems = computed(() => {
	if (saveButtonType !== 'dropdown') return [];

	return [
		{
			label: t('listing.views.save.save_for_everyone'),
			onSelect: () => {
				emit('saveToView');
			},
		},
		{
			label: t('listing.views.save.create_new_view'),
			onSelect: () => {
				emit('saveAsNew');
			},
		},
	];
});
</script>

<template>
	<div class="flex items-center gap-2">
		<DButton
			v-if="saveButtonType !== null"
			data-testid="clear-button"
			:label="$t('listing.views.save.reset')"
			variant="ghost"
			color="neutral"
			size="sm"
			@click="emit('reset')"
		/>

		<DButton
			v-if="saveButtonType === 'single'"
			data-testid="save-button"
			:label="$t('common.save')"
			variant="outline"
			color="neutral"
			size="sm"
			@click="emit('save')"
		/>

		<DDropdownMenu
			v-else-if="saveButtonType === 'dropdown'"
			:items="dropdownItems"
			size="sm"
		>
			<DButton
				data-testid="save-dropdown"
				:label="$t('common.save')"
				color="neutral"
				variant="outline"
				size="sm"
				:trailing-icon="appConfig.ui.icons.chevronDown"
			/>
		</DDropdownMenu>
	</div>
</template>
